import type { components } from 'schema.ts'

import type {
	ECP_EZE_TABLE_KEYS,
	ICPEZETablePropTypes
} from '~/portal/components/base'
import type {
	ICPAddressParkFormPropTypes,
	ICPFormApplicantFormData,
	ICPFormCertificationInfoPropTypes
} from '~/portal/components/form'

export interface IApplicantInformationState {
  selectedApplicant: string | null
  controlState: 'newApplicant' | 'existingApplicant'
  applicant: ICPFormApplicantFormData
  certificateHolder: ICPFormApplicantFormData
}

export interface IScopeCertificationState {
  formData: ICPFormCertificationInfoPropTypes['formData']
  ezeTables: {
    [ECP_EZE_TABLE_KEYS.New]: ICPEZETablePropTypes['modelValue']
    [ECP_EZE_TABLE_KEYS.Old]: ICPEZETablePropTypes['modelValue']
    [ECP_EZE_TABLE_KEYS.Moderate]: ICPEZETablePropTypes['modelValue']
  }
}

export enum CertificationPlanEnum {
  Standard = 'BASIC',
  Express = 'EXPRESS'
}

export interface IProjectCreationStoreTypes {
  projectId: number | undefined
  certificationPlan: CertificationPlanEnum
  applicantInformation: IApplicantInformationState
  powerPlantAddress: ICPAddressParkFormPropTypes['formData']
  scopeCertification: IScopeCertificationState
}

export interface IProjectListItem extends IProjectCreationStoreTypes
{
  time: string
}

export type IProjectCreationDraftItem = IProjectListItem

export interface ITemplateListItem {
  project: IProjectListItem
  templateId: number
  templateName: string
}

export type IProjectCreationDefinitionPayload = components['schemas']['CreateProject']
